export const EXCHANGE_ORDER_MAX_INTERVAL = 30;
export const EXCHANGE_ORDER_MAX_START_DAY = 90;
